var addLeadingZero, countdownTimeKey, countdownTimestamp, millisRemaining, timeRemaining;

timeRemaining = function(timeRemainingMilliseconds) {
  var days, hours, millisecondsLeft, minutes, seconds;
  if (timeRemainingMilliseconds == null) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
  millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
  hours = Math.floor(millisecondsLeft / (1000 * 3600));
  millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
  minutes = Math.floor(millisecondsLeft / (1000 * 60));
  millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
  seconds = Math.floor(millisecondsLeft / 1000);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

millisRemaining = function(endTime) {
  var millsRemaining, rightNow;
  if (endTime == null) {
    return 0;
  }
  rightNow = new Date().getTime();
  millsRemaining = endTime - rightNow;
  if (millsRemaining < 0) {
    return 0;
  } else {
    return millsRemaining;
  }
};

addLeadingZero = function(number) {
  if (number < 0) {
    return;
  }
  if (number < 10) {
    return "0" + number;
  } else {
    return "" + number;
  }
};

countdownTimeKey = function(timeLeft, isUrgencyPricing) {
  switch (false) {
    case !(timeLeft.days > 1):
      if (isUrgencyPricing) {
        return ".countdown_time_many_days";
      } else {
        return ".countdown_days";
      }
      break;
    case timeLeft.days !== 1:
      return ".countdown_time_1_day";
    default:
      return ".countdown_time_today";
  }
};

countdownTimestamp = function(timeLeft) {
  var hh, mm, ss;
  hh = addLeadingZero(timeLeft.hours);
  mm = addLeadingZero(timeLeft.minutes);
  ss = addLeadingZero(timeLeft.seconds);
  return hh + ":" + mm + ":" + ss;
};

if (typeof window !== "undefined" && window !== null) {
  if (window.CountdownTimer == null) {
    window.CountdownTimer = {};
  }
  if (CountdownTimer.Helpers == null) {
    CountdownTimer.Helpers = {};
  }
  CountdownTimer.Helpers.timeRemaining = timeRemaining;
  CountdownTimer.Helpers.millisRemaining = millisRemaining;
  CountdownTimer.Helpers.countdownTimeKey = countdownTimeKey;
  CountdownTimer.Helpers.countdownTimestamp = countdownTimestamp;
}

if (typeof module !== "undefined" && module !== null) {
  module.exports = {
    timeRemaining: timeRemaining,
    millisRemaining: millisRemaining,
    countdownTimeKey: countdownTimeKey,
    countdownTimestamp: countdownTimestamp
  };
}

//# sourceMappingURL=data:application/json;base64,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
